.screen {
  position: fixed;
  z-index: 90;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #f3f1ed;
  opacity: 1;
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
}

.trigger {
  width: min(100%, 430px);
  min-height: 100%;
  margin: 0;
  border: 0;
  padding: 0;
  color: inherit;
  background: transparent;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.trigger:disabled {
  cursor: default;
}

.stage {
  position: relative;
  display: block;
  width: 100%;
  height: 100vh;
  height: 100svh;
  overflow: hidden;
  background: transparent;
}

.panel {
  position: absolute;
  inset: 0;
  display: block;
  opacity: 1;
  filter: blur(0);
  will-change: transform, filter, opacity;
}

.topPanel {
  z-index: 2;
  transform-origin: 50% 100%;
}

.bottomPanel {
  z-index: 1;
  transform-origin: 50% 0;
}

.lowerBody,
.closedFlap {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  user-select: none;
}

.lowerBody {
  z-index: 1;
}

.closedFlap {
  z-index: 3;
}

.invited,
.openCue {
  position: absolute;
  z-index: 6;
  left: 0;
  right: 0;
  color: #746455;
  font-family: var(--font-hero);
  font-weight: 700;
  line-height: 1.5;
  text-align: center;
}

.invited {
  top: 21.5%;
  font-size: 16px;
  letter-spacing: 0.22em;
  text-indent: 0.22em;
}

.seal {
  position: absolute;
  z-index: 7;
  top: 50%;
  left: 50%;
  width: clamp(104px, 30vw, 132px);
  aspect-ratio: 1;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.trigger:not(:disabled) .seal {
  animation-name: sealPulse;
  animation-duration: 2.2s;
  animation-delay: 0.35s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: 2;
}

.seal img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.monogram {
  position: absolute;
  top: 50%;
  left: 50%;
  color: #76604a;
  font-family: var(--font-hero);
  font-size: clamp(31px, 8.5vw, 40px);
  font-weight: 400;
  letter-spacing: -0.18em;
  text-indent: -0.18em;
  text-shadow: 0 1px 0 rgb(255 255 255 / 70%);
  transform: translate(-50%, -52%);
}

.openCue {
  bottom: 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  letter-spacing: 0.2em;
  text-indent: 0.2em;
}

.openHint {
  font-family: var(--font-body);
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.04em;
  text-indent: 0.04em;
}

.trigger:focus-visible {
  outline: 2px solid #8b95a3;
  outline-offset: -4px;
}

.screen[data-state='opening'] {
  animation: revealFocus 1s cubic-bezier(0.65, 0, 0.35, 1) forwards;
}

.screen[data-state='opening'] .topPanel {
  animation: topPanelExit 1s cubic-bezier(0.65, 0, 0.35, 1) forwards;
}

.screen[data-state='opening'] .bottomPanel {
  animation: bottomPanelExit 1s cubic-bezier(0.65, 0, 0.35, 1) forwards;
}

@keyframes sealPulse {
  0%,
  100% {
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    transform: translate(-50%, -50%) scale(1.045);
  }
}

@keyframes topPanelExit {
  0% {
    opacity: 1;
    filter: blur(0);
    transform: translateY(0);
  }
  45% {
    opacity: 0.94;
    filter: blur(2px);
  }
  100% {
    opacity: 0;
    filter: blur(9px);
    transform: translateY(-115%);
  }
}

@keyframes bottomPanelExit {
  0% {
    opacity: 1;
    filter: blur(0);
    transform: translateY(0);
  }
  45% {
    opacity: 0.94;
    filter: blur(2px);
  }
  100% {
    opacity: 0;
    filter: blur(9px);
    transform: translateY(115%);
  }
}

@keyframes revealFocus {
  0% {
    background-color: rgb(243 241 237 / 100%);
    -webkit-backdrop-filter: blur(12px);
    backdrop-filter: blur(12px);
  }
  50% {
    background-color: rgb(243 241 237 / 38%);
    -webkit-backdrop-filter: blur(8px);
    backdrop-filter: blur(8px);
  }
  100% {
    background-color: rgb(243 241 237 / 0%);
    -webkit-backdrop-filter: blur(0);
    backdrop-filter: blur(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .trigger:not(:disabled) .seal {
    animation-name: none;
  }

  .screen[data-state='opening'] {
    animation: reducedReveal 0.18s ease forwards;
  }

  .screen[data-state='opening'] .topPanel,
  .screen[data-state='opening'] .bottomPanel {
    animation: none;
  }
}

@keyframes reducedReveal {
  to {
    opacity: 0;
    -webkit-backdrop-filter: blur(0);
    backdrop-filter: blur(0);
  }
}
